module.exports = __webpack_public_path__ + "media/images/menu-336cd78fcdd80a36d92d475efbf21b56.png";